import React from 'react';
import { useParams } from 'react-router-dom';
import LibModal from '../../../features/LibModal/LibModal';
import NotFound from '../../../features/NotFound/NotFoundPage';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import { GetSearchParams } from '../../../utils/URL';
import ModalChangeCustomerCurrency from '../../Agency/List/Modals/ModalChangeCustomerCurrency';
import AddressCont from '../Address/AddressCont';
import CustomersProvider from '../CustomerProvider';
import EditBillToModal from '../Modals/EditBillToModal';
import CustomerDetailsStatus from './Components/CustomerDetailsStatus';
import CustomerInfo from './Components/CustomerInfo';
import CustomerTableTab from './Components/CustomerTableTab';
import UserInvoicesPage from './Components/TabTablePages/Invoices/UserInvoicesPage';
import UserPaymentsPage from './Components/TabTablePages/Payments/UserPaymentsPage';
import UserServicesPage from './Components/TabTablePages/Services/UserServicesPage';
import UserSubscriptionsPage from './Components/TabTablePages/Subscriptions/UserSubscriptionsPage';
import UserSupportTicketsPage from './Components/TabTablePages/SupportTickets/UserSupportTicketsPage';
import CustomerDetailsProvider, { useCustomerDetails } from './CustomerDetailsProvider';
import AddNewServiceModal from './Modals/AddNewServiceModal';
import AddNewSubscriptions from './Modals/AddNewSubscriptions';

function TabComponentRender({ data }) {
    const tabName = GetSearchParams('tab') || 'subscriptions';
    switch (tabName) {
        case 'subscriptions':
            return <UserSubscriptionsPage data={data} />;
        case 'invoices':
            return <UserInvoicesPage data={data} />;
        case 'payments':
            return <UserPaymentsPage data={data} />;
        case 'support-ticket':
            return <UserSupportTicketsPage data={data} />;
        case 'services':
            return <UserServicesPage data={data} />;
        default:
            return null;
    }
}

function PageCont() {
    const {
        customerDetailsData,
        setReloadKey,
        handleReload,
        openAppInfoModal,
        setOpenAppInfoModal,
        openModal,
        closeModal,
        modalType: ownModalType
    } = useCustomerDetails();

    const { modalType, closeModal: closeTemplateModal } = useTemplate();

    PageTitle(customerDetailsData.organization || 'Customer Details');

    if (customerDetailsData && Object.keys(customerDetailsData).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Customer Found!"
                    btnTitle="Back to list"
                    path="/customers"
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="agency_customers_details_page inner_page_cont overflow-x-hidden">
            {/* <CustomersDetailsHeader /> */}
            <CustomerInfo data={customerDetailsData} handleReload={handleReload} />
            <CustomerDetailsStatus data={customerDetailsData} />
            {/* Address Modal */}
            <AddressCont addressData={customerDetailsData?.addresses} />

            <div className="customers_details_body pb-40">
                <CustomerTableTab data={customerDetailsData} openModal={openModal} />
                <TabComponentRender data={customerDetailsData} />
            </div>
            {openAppInfoModal && (
                <LibModal title="App Features" setOpen={setOpenAppInfoModal}>
                    modal body
                </LibModal>
            )}

            {ownModalType === 'new-subscription' && (
                <LibModal
                    title="Order New Subscription"
                    setOpen={closeModal}
                    className="!w-[1000px]"
                >
                    <AddNewSubscriptions
                        data={customerDetailsData}
                        closeModal={closeModal}
                        setReloadKey={setReloadKey}
                    />
                </LibModal>
            )}
            {ownModalType === 'new-service' && (
                <LibModal title="Purchase New Service" setOpen={closeModal} className="!w-[900px]">
                    <AddNewServiceModal
                        data={customerDetailsData}
                        closeModal={closeModal}
                        setReloadKey={setReloadKey}
                    />
                </LibModal>
            )}

            {/* Change Customer Currency Modal */}
            {modalType === 'CHANGE_CUSTOMER_INFO_CURRENCY_MODEL' && (
                <LibModal
                    title="Create New Agency Customer"
                    setOpen={closeTemplateModal}
                    className="md:!w-[450px]"
                >
                    <ModalChangeCustomerCurrency handleReload={handleReload} />
                </LibModal>
            )}

            {/* Edit Bill To Modal */}
            {modalType === 'EDIT_BILL_TO_MODAL' && (
                <LibModal
                    title="Edit Bill To"
                    setOpen={closeTemplateModal}
                    className="md:!w-[600px]"
                >
                    <EditBillToModal
                        data={customerDetailsData}
                        handleReload={handleReload}
                        closeModal={closeTemplateModal}
                    />
                </LibModal>
            )}
        </div>
    );
}

function CustomersDetailsPage() {
    const { userID, agencyId } = useParams();

    return (
        <CustomersProvider>
            <CustomerDetailsProvider agencyId={agencyId} customerId={userID}>
                <PageCont />
            </CustomerDetailsProvider>
        </CustomersProvider>
    );
}

export default CustomersDetailsPage;
